module.exports = "https://web-assets.ifttt.com/packs/media/fonts/avenir_next-bold-4de26cb0.ttf";